import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedAzureApp from "./EmbeddedAzureApp";
const AzureApp = () => {
  const { t } = useTranslation("enterprise_integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("azure.app.title") }, /* @__PURE__ */ React.createElement("span", null, t("azure.app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "azure.app.requirement",
      components: {
        externalLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://azure.microsoft.com/en-us/products/event-hubs" })
      }
    }
  ), " ")), /* @__PURE__ */ React.createElement(EmbeddedAzureApp, null));
};
export default AzureApp;
